/*
 * @Description:
 * @Author: yaoxiaoxiao
 * @Date: 2021-03-23 17:37:01
 * @LastEditors: yaoxiaoxiao
 * @LastEditTime: 2021-03-23 17:37:30
 */
import CImgView from './index.vue'
export default CImgView
